import Alpine from 'alpinejs';
import Splide from '../../Helper/NeosSplide';

const defaultOptions = {
    withLightbox: false,
    galleryType: 'slider',
    splide: {
        perPage: 1,
        gap: 20,
    }
}

Alpine.data('imageSlider', (options = defaultOptions) => ({
    ...options,

    // Internal Props
    lightboxOpen: false,
    outerSlider: null,
    innerSlider: null,

    get inNeosBackend() {
        return window.name === 'neos-content-main';
    },

    init() {
        const isGrid = this.galleryType === 'grid';

        // Only create outer Splide for slider mode
        if (!isGrid) {
            this.outerSlider = new Splide(this.$root.querySelector('.image-slider__outer'), {
                ...this.splide,
                drag: !this.inNeosBackend,
                breakpoints: {
                    640: { perPage: 1 },
                    768: { perPage: 2 },
                }
            });
        }

        if (this.withLightbox && !this.inNeosBackend) {
            this.innerSlider = new Splide(this.$root.querySelector('.image-slider__inner'), {
                type: 'fade'
            });

            if (isGrid) {
                // Grid mode: use DOM click delegation for lightbox
                const gridItems = this.$root.querySelectorAll('.image-slider__outer .splide__slide');
                gridItems.forEach((item, index) => {
                    item.addEventListener('click', () => {
                        this.innerSlider.go(index);
                        this.lightboxOpen = true;
                    });
                });
                this.innerSlider.mount();
            } else {
                // Slider mode: use Splide click event
                this.outerSlider.on('click', (slide) => {
                    this.innerSlider.go(slide.index);
                    setTimeout(() => { this.lightboxOpen = true }, 100);
                });
                this.outerSlider.mount();
                this.innerSlider.mount();
            }

            this.$watch('lightboxOpen', (open) => {
                if (this.innerSlider) {
                    this.innerSlider.options = { keyboard: open ? 'global' : false };
                }
            });
        } else if (!isGrid) {
            this.outerSlider.mount();
        }
    },

    showLightboxSlide(slideNumber) {
        if (this.innerSlider) {
            this.innerSlider.go(slideNumber);
        }
    }
}));
